import {
  PageTopBar,
  ThreeSlotLayout,
} from "../../../../../common/components/page_top_bar";
import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import { Breadcrumbs, Link, TablePagination, Typography } from "@mui/material";
import RefreshButton from "../../../../../common/components/refresh_button";
import { useMemo } from "react";
import { GenerateQualidadeIndicadoresColumns } from "./columns/qualidade_indicadores";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { useQualidadeIndicadoresListaViewModel } from "../../viewModels/qualidade_Indicadores_view_model";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { IndicadoresLista } from "../../../domain/models/indicadores_lista";
import { LegendComponent } from "../../../../../common/components/legend_component";
import { LegendItemComponent } from "../../../../../common/components/legend_item_component";
import { LegendIcon } from "../../../../../common/components/legend_icon";
import { Header } from "./components/header";
import { IndicadoresModal } from "./components/indicadores_modal";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal";

export const Indicadores_Lista = () => {
  const viewModel = useQualidadeIndicadoresListaViewModel();

  const QualidadeIndicadoresListalColumns = useMemo(() => {
    return GenerateQualidadeIndicadoresColumns({
      onActionEditar: viewModel.handleCadastroIndicadoresOpenState,
      onActionDeletar: viewModel.handleDeleteIndicadoresModalOpenState,
    });
  }, [
    viewModel.handleCadastroIndicadoresOpenState,
    viewModel.handleDeleteIndicadoresModalOpenState,
  ]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2 items-center">
              <div className="w-[12rem]">
                <PrimaryButton
                  aria-haspopup="true"
                  onClick={() => viewModel.handleSubmitReport()}
                  buttonColor="yellow"
                >
                  Relatórios
                </PrimaryButton>
              </div>
              <div className="w-[150px] ">
                <PrimaryButton
                  startIcon={
                    <DynamicIcon
                      nameIcon="AddRounded"
                      size={25}
                      className="text-white"
                    />
                  }
                  onClick={() =>
                    viewModel.handleCadastroIndicadoresOpenState(null, true)
                  }
                >
                  Novo
                </PrimaryButton>
              </div>
            </div>
          }
        />
      </PageTopBar>
      <form>
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Qualidade
            </Link>
            <Typography className="text-primary-green">
              Objetivos da Qualidade
            </Typography>
          </Breadcrumbs>
          <div className="div flex justify-between items-center flex-col gap-6">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">
                Objetivos da Qualidade
              </h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>
            <Header
              onClearFilters={viewModel.handleClearFilters}
              handleTipoPesquisa={viewModel.handleTipoPesquisaChange}
              handleStatus={viewModel.handleStatusChange}
              handlePesquisa={viewModel.handlePesquisaChange}
              pesquisa={viewModel.filters.pesquisa}
              tipoPesquisa={viewModel.filters.tipoPesquisa}
              status={viewModel.filters.status}
            />
            <div className="w-full flex flex-row justify-between items-center">
              <LegendComponent>
                <LegendItemComponent
                  icon={<LegendIcon color="green" title="A" />}
                  label="Ativo"
                />
                <LegendItemComponent
                  icon={<LegendIcon color="red" title="I" />}
                  label="Inativo"
                />
              </LegendComponent>
            </div>
            <StyledDataGrid
              tableName="Indicadores_Lista"
              disableColumnMenu={false}
              getRowId={(row: IndicadoresLista) => row.IdIndicador}
              columns={QualidadeIndicadoresListalColumns}
              loading={viewModel.loading}
              rows={viewModel.indicadoresLista}
              rowCount={viewModel.pagination.totalItems}
              sx={{
                "& .status-header": {
                  backgroundColor: "#AFDFD5",
                  color: "#000",
                },
              }}
              pageSizeOptions={[10]}
              paginationMode="server"
              paginationModel={{
                page: viewModel.pagination.page,
                pageSize: viewModel.pagination.rowsPerPage,
              }}
              autoHeight={true}
              textSize="medio"
              getRowHeight={() => "auto"}
            />

            <TablePagination
              component="div"
              count={viewModel.pagination.totalItems}
              page={viewModel.pagination.page - 1}
              onPageChange={(_, p) => viewModel.handlePageChange(p)}
              rowsPerPageOptions={[10, 25, 50, 100]}
              rowsPerPage={viewModel.pagination.rowsPerPage}
              onRowsPerPageChange={(e) =>
                viewModel.handleRowsPerPageChange(parseInt(e.target.value))
              }
            />
          </div>
        </div>
      </form>

      {/* Modal */}
      <IndicadoresModal
        loading={viewModel.loading}
        onClose={() =>
          viewModel.handleCadastroIndicadoresOpenState(null, false)
        }
        onSubmit={viewModel.handleIndicadoresSubmit}
        open={viewModel.indicadoresModal}
        saving={viewModel.saving}
        selectedIdIndicadores={viewModel.selectedIdIndicadores}
        onOpenChangeHistory={(id, tabelaTipo) =>
          viewModel.handleOpenChangeHistory(id, tabelaTipo)
        }
      />

      <ChangeHistoryModal changeHistoryHandler={viewModel.changeHistory} />

      <ReportViewerModal reportViewerState={viewModel.reportViewerState} />

      {/* Deletar Registro */}
      <DeleteDialog
        open={viewModel.indicadoresaDeleteModal}
        saving={viewModel.saving}
        onClose={() =>
          viewModel.handleDeleteIndicadoresModalOpenState(null, false)
        }
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirmaIndicadores}
      />
    </>
  );
};
